var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lsv-page-standalone"},[_c('LSVCompactNew')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }